<template>
    <div class="operation-log">
        <div class="filter-section">
            <div class="filter-row">
                <div class="filter-item">
                    <span>操作人</span>
                    <a-select placeholder="请选择操作人" style="width: 200px" v-model="filters.operator" allowClear
                        @change="handleFilterChange">
                        <a-select-option v-for="op in operatorOptions" :key="op" :value="op">{{ op }}</a-select-option>
                    </a-select>
                </div>
                <div class="filter-item">
                    <span>操作模块</span>
                    <a-select placeholder="请选择操作模块" style="width: 200px" v-model="filters.module" allowClear
                        @change="handleFilterChange">
                        <a-select-option v-for="module in moduleOptions" :key="module" :value="module">
                            {{ module }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="filter-item">
                    <span>操作名</span>
                    <a-select placeholder="请选择操作名" style="width: 200px" v-model="filters.name" allowClear
                        @change="handleFilterChange">
                        <a-select-option v-for="opName in operationNameOptions" :key="opName" :value="opName">
                            {{ getOperationDisplay(opName) }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="filter-item">
                    <span>操作内容</span>
                    <a-input placeholder="请输入操作内容" style="width: 200px" v-model="filters.content" allowClear
                        @change="debouncedFilterChange" />
                </div>
            </div>
            <div class="filter-row">
                <div class="filter-item">
                    <span>操作时间</span>
                    <a-range-picker style="width: 240px" v-model="filters.timeRange" format="YYYY-MM-DD"
                        @change="handleFilterChange" />
                </div>
                <div class="filter-item">
                    <span>业务编码</span>
                    <a-input placeholder="请输入业务编码" style="width: 200px" v-model="filters.businessCode" allowClear
                        @change="debouncedFilterChange" />
                </div>
                <div class="filter-item">
                    <span>IP地址</span>
                    <a-input placeholder="请输入IP地址" style="width: 200px" v-model="filters.ip" allowClear
                        @change="debouncedFilterChange" />
                </div>
                <div class="filter-item button-group">
                    <a-button icon="reload" @click="handleReset">重置</a-button>
                </div>
            </div>
        </div>

        <a-table rowKey="id" :columns="columns" :dataSource="allLogData" :pagination="pagination" :loading="loading" bordered
            size="middle" :rowClassName="() => 'table-row'" @change="handleTableChange" :scroll="{ x: 1200 }">
            <span slot="operation" slot-scope="text, record">
                <a-button type="link" size="small" class="detail-btn" @click="showDetails(record)">详情</a-button>
            </span>
        </a-table>
        <div class="export-section">
            <a-button type="primary" icon="download" :loading="exportLoading" @click="handleExport">导出日志</a-button>
        </div>
    </div>
</template>

<script>
import { debounce } from 'lodash'; // 引入 lodash 的 debounce 函数
import { getOperationLogsWithFullPath, exportOperationLogsWithFullPath } from '@/api/operationLog';
import { userList } from '@/api/account'
import { getOperationDisplay, parseOperationContent } from './operationMap';
export default {
    name: 'OperationLog',
    data() {
        return {

            filters: {
                operator: undefined,
                module: undefined,
                name: undefined,
                content: '',
                timeRange: [],
                businessCode: '',
                ip: '', // 添加IP筛选
            },
            userNames: [], // 添加用户名列表
            columns: [
                { title: '日志编号', dataIndex: 'id', key: 'id', width: 80, align: 'center' },
                { title: '操作人', dataIndex: 'operator', key: 'operator', width: 100, align: 'center' },
                { title: '操作模块', dataIndex: 'module', key: 'module', width: 120, align: 'center' },
                { title: '操作名', dataIndex: 'nameDisplay', key: 'nameDisplay', width: 180, align: 'center' },
                { 
                    title: '操作内容', 
                    dataIndex: 'contentDisplay',  // 直接使用已解析的字段
                    key: 'contentDisplay', 
                    width: 300, 
                    ellipsis: true,
                    customRender: (text) => {
                        // 如果已有解析结果就直接使用，否则显示'-'
                        return text || '-';
                    }
                },
                { 
                    title: '状态', 
                    dataIndex: 'status', 
                    key: 'status', 
                    width: 80, 
                    align: 'center',
                    customRender: (text) => {
                        const statusMap = {
                            '成功': { color: 'green', text: '成功' },
                            '失败': { color: 'red', text: '失败' },
                            '进行中': { color: 'blue', text: '进行中' }
                        };
                        const status = statusMap[text] || { color: 'default', text: text || '-' };
                        return status.text;
                    }
                },
                {
                    title: '操作时间',
                    dataIndex: 'time',
                    key: 'time',
                    width: 180,
                    align: 'center',
                    sorter: (a, b) => new Date(a.time) - new Date(b.time)
                },
                { title: '业务编号', dataIndex: 'businessCode', key: 'businessCode', width: 100, align: 'center' },
                { title: 'IP', dataIndex: 'ip', key: 'ip', width: 140, align: 'center' },
                {
                    title: '操作',
                    key: 'operation',
                    width: 80,
                    align: 'center',
                    fixed: 'right',
                    scopedSlots: { customRender: 'operation' }
                }
            ],
            allLogData: [], // 初始化为空数组
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => `共 ${total} 条`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100']
            },
            loading: false, // 添加加载状态
            exportLoading: false, // 添加导出加载状态
            operatorOptions: [], // 初始化为空数组
            moduleOptions: [], // 初始化为空数组
            operationNameOptions: [] // 初始化为空数组
        }
    },
    created() {
        // 创建防抖处理函数
        this.debouncedFilterChange = debounce(this.handleFilterChange, 300);
    },
    mounted() {
        // 直接加载数据，用户过滤暂时禁用
        this.fetchData();
        // 异步获取用户列表（不阻塞主要功能）
        this.fetchUserList();
    },
    methods: {
        // 操作名映射函数（在模板中使用）
        getOperationDisplay,
        // 操作内容解析函数
        parseOperationContent,
        
        // 获取用户列表（用于筛选选项）
        async fetchUserList() {
            try {
                const response = await userList();
                if (response && response.code === 200) {
                    // 提取用户名字段
                    this.userNames = response.data.map(user => user.name).filter(Boolean);
                }
            } catch (error) {
                // 静默处理错误，不影响主要功能
            }
        },

        // 导出日志数据
        async handleExport() {
            this.exportLoading = true;
            try {
                // 准备导出参数，与查询参数相同
                const params = {
                    operator: this.filters.operator || null,
                    module: this.filters.module || null,
                    name: this.filters.name || null,
                    content: this.filters.content || "",
                    business_code: this.filters.businessCode || "",
                    start_time: null,
                    end_time: null,
                    ip: this.filters.ip || "", // 添加IP地址参数
                    responseType: 'blob'
                };

                // 处理时间范围
                if (this.filters.timeRange && this.filters.timeRange.length === 2) {
                    params.start_time = this.filters.timeRange[0].format('YYYY-MM-DD');
                    params.end_time = this.filters.timeRange[1].format('YYYY-MM-DD');
                }

                // 调用导出API - 修改为POST请求
                const response = await exportOperationLogsWithFullPath(params);

                // 创建下载链接
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `操作日志_${new Date().toLocaleDateString()}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(link.href);

                this.$message.success('导出成功');
            } catch (error) {
                this.$message.error('导出失败');
                console.error('导出失败:', error);
            } finally {
                this.exportLoading = false;
            }
        },

        // 获取数据的方法
        async fetchData() {
            this.loading = true;
            try {
                // 准备请求参数，包含分页和筛选条件
                const params = {
                    page: this.pagination.current,
                    page_size: this.pagination.pageSize,
                    operator: this.filters.operator || null,
                    module: this.filters.module || null,
                    name: this.filters.name || null,
                    content: this.filters.content || "",
                    business_code: this.filters.businessCode || "",
                    ip: this.filters.ip || ""
                };

                // 处理时间范围
                if (this.filters.timeRange && this.filters.timeRange.length === 2) {
                    params.start_time = this.filters.timeRange[0].format('YYYY-MM-DD');
                    params.end_time = this.filters.timeRange[1].format('YYYY-MM-DD');
                }

                // 调用 API 获取数据
                const response = await getOperationLogsWithFullPath(params);

                if (response && response.code === 200) {
                    // 根据实际API响应结构调整
                    const logData = response.data || [];
                    const total = response.count || 0;

                    // 直接显示所有数据
                    const filteredLogData = logData;

                    // 首次加载时，提取筛选选项（只包含有效的操作人）
                    if (this.operatorOptions.length === 0) {
                        this.operatorOptions = [...new Set(filteredLogData.map(item => item.operator).filter(Boolean))];
                        this.moduleOptions = [...new Set(filteredLogData.map(item => item.module).filter(Boolean))];
                        this.operationNameOptions = [...new Set(filteredLogData.map(item => item.name).filter(Boolean))];
                    }

                    // 将过滤后的数据映射到前端表格所需的格式
                    this.allLogData = filteredLogData.map(item => {
                        const contentDisplay = parseOperationContent(item.content, item.name);
                        
                        // 🔍 调试日志：查看解析过程
                        if (item.id === 42) {
                            console.log('📊 ID 42 解析详情:', {
                                原始内容: item.content,
                                操作名: item.name,
                                解析结果: contentDisplay
                            });
                        }
                        
                        return {
                            key: item.id, // 添加key属性
                            id: item.id,
                            operator: item.operator || '',
                            module: item.module || '',
                            name: item.name || '',
                            nameDisplay: getOperationDisplay(item.name) || item.name || '',
                            content: item.content || '',
                            contentDisplay: contentDisplay, // 解析后的内容
                            status: item.status || '成功', // 添加状态字段
                            time: item.create_time || '', // 注意字段名是create_time
                            businessCode: item.business_code || '', // 注意字段名是business_code
                            ip: item.ip || ''
                        };
                    });

                    // 更新分页信息（使用API返回的总数）
                    this.pagination.total = total;
                } else {
                    this.allLogData = [];
                    this.pagination.total = 0;
                }
            } catch (error) {
                this.$message.error('获取日志数据失败');
                console.error('获取日志数据失败:', error);
            } finally {
                this.loading = false;
            }
        },
        handleFilterChange() {
            // 当筛选条件变化时，重置到第一页并重新获取数据
            this.pagination.current = 1;
            this.fetchData();
        },
        handleTableChange(pagination, filters, sorter) {
            // 处理表格分页和排序变化
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;

            // 如果需要处理排序
            if (sorter && sorter.field) {
                // 这里可以添加排序逻辑，如果后端支持排序
                console.log('排序字段:', sorter.field);
                console.log('排序方式:', sorter.order);
            }

            // 重新获取数据
            this.fetchData();
        },
        handleReset() {
            // 重置所有筛选条件
            this.filters = {
                operator: undefined,
                module: undefined,
                name: undefined,
                content: '',
                timeRange: [],
                businessCode: '',
                ip: '' // 重置IP筛选
            };

            // 重置分页并重新获取数据
            this.pagination.current = 1;
            this.fetchData();
        },

        // 渲染详情内容
        renderDetailContent(h, record) {
            const labelStyle = "color: #999; min-width: 90px; display: inline-block;";
            const rowStyle = "margin-bottom: 12px;";
            const statusColor = record.status === '成功' ? '#52c41a' : (record.status === '失败' ? '#ff4d4f' : '#1890ff');
            
            return h('div', { style: 'max-height: 500px; overflow-y: auto; padding: 10px;' }, [
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '日志编号：'),
                    h('span', { style: 'font-weight: 500;' }, record.id)
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '操作人：'),
                    h('span', { style: 'font-weight: 500;' }, record.operator)
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '操作模块：'),
                    h('span', {}, record.module)
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '操作名称：'),
                    h('span', {}, record.nameDisplay || record.name)
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '状态：'),
                    h('span', { style: `color: ${statusColor}` }, record.status || '成功')
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle + 'vertical-align: top;' }, '操作内容：'),
                    h('div', { 
                        style: 'display: inline-block; max-width: 450px; word-break: break-all; white-space: pre-wrap; background: #f5f5f5; padding: 8px; border-radius: 4px; font-size: 13px; line-height: 1.6;' 
                    }, record.contentDisplay || record.content || '无')
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle + 'vertical-align: top;' }, '原始数据：'),
                    h('div', { 
                        style: 'display: inline-block; max-width: 450px; word-break: break-all; white-space: pre-wrap; background: #fafafa; padding: 8px; border-radius: 4px; font-family: monospace; font-size: 11px; color: #666; border: 1px solid #e8e8e8;' 
                    }, record.content || '无')
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '操作时间：'),
                    h('span', {}, record.time)
                ]),
                h('div', { style: rowStyle }, [
                    h('span', { style: labelStyle }, '业务编号：'),
                    h('span', {}, record.businessCode || '-')
                ]),
                h('div', {}, [
                    h('span', { style: labelStyle }, 'IP地址：'),
                    h('span', {}, record.ip)
                ])
            ]);
        },

        showDetails(record) {
            this.$info({
                title: '操作日志详情',
                content: h => this.renderDetailContent(h, record),
                width: 650,
                icon: null,
                okText: '关闭',
                maskClosable: true,
                keyboard: true
            });
        }
    }
}
</script>

<style lang="less" scoped>
.export-section {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
}

.operation-log {
    padding: 24px;
    background-color: #fff;

    .filter-section {
        margin-bottom: 24px;
        padding: 16px 24px;
        background-color: #f9f9f9;
        border-radius: 2px;
        border: 1px solid #f0f0f0;
    }

    .filter-row {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .filter-item {
        display: flex;
        align-items: center;
        margin-right: 24px;
        margin-bottom: 8px;

        span {
            margin-right: 8px;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
        }

        &.button-group {
            margin-left: auto;
        }
    }

    :deep(.ant-table) {
        .ant-table-thead>tr>th {
            background-color: #f5f7fa;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 500;
        }

        .table-row {
            &:hover {
                background-color: #e6f7ff;
            }
        }
    }

    .detail-btn {
        color: #1890ff;
        padding: 0 4px;
        cursor: pointer;

        &:hover {
            color: #40a9ff;
        }
    }
}
</style>